export const emptyImagePlaceholder = '/assets/images/empty-image.svg'
